import React from 'react';

import { HighlightedGraphQLName } from 'src/components/highlightedGraphQLName/HighlightedGraphQLName';
import { explainRegexMatch } from 'src/lib/explainRegexMatch';

interface HighlightedListItemNameProps {
  itemName: string;
  searchTerm: string | undefined;
  loading: boolean;
}

export const HighlightedListItemName = ({
  itemName,
  searchTerm,
  loading,
}: HighlightedListItemNameProps): React.ReactElement => {
  // Remove non-alphanumeric characters from the search term since that's what
  // we end up searching for anyway. Note that underscores are valid search
  // characters and they are not stripped out here.
  const sanitizedSearchTerm = (searchTerm || '').replace(/\W/g, '');
  if (!sanitizedSearchTerm || loading) {
    return <>{itemName}</>;
  }

  const regex = RegExp(`(${sanitizedSearchTerm})`, 'i').exec(itemName);

  return (
    <HighlightedGraphQLName
      name={itemName}
      regexResult={explainRegexMatch(regex)}
      singleLine={true}
    />
  );
};
